import React, { useState } from "react";
import { Redirect } from 'react-router-dom';
import BgLeftImage from 'views/components/Login/BgLeftImage';
import '../../../index.scss';
import 'views/pages/Home/Home.scss';
import CopyrightFooter from 'views/components/Login/CopyrightFooter';
import { SignInGoogle } from "views/components/Login/SignInGoogle";
import { SignInDefault } from "views/components/Login/SignInDefault";

interface LoginPageState {
  email: string;
  password: string;
  error: string;
  loading: boolean;
}

const LoginPage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  if (isLoggedIn) {
    return <Redirect to="/home" />;
  }
 return (
      <div className="site-wrap logged-out main-page">
        <BgLeftImage />
        <div className="reg-page__content-wrap">
          <div className="reg-page__primary">
            <div className="container reg-container">
              <div className="auth-container">
                <h2 className="text-center pt-0 header-fix">
                Thomas Program Configuration Tool
                </h2>

                <SignInDefault onSignedIn={() => { setIsLoggedIn(true); }} />


                </div>
                <div id="social" style={{ textAlign: "center", paddingTop: "8px", lineHeight: "40px" }}>
                or
                <br />
                <SignInGoogle onSignedIn={() => { setIsLoggedIn(true); }} />
              </div>
                <CopyrightFooter />
              </div>
            </div>
          </div>
        </div>
    );
  
};

export default LoginPage;
